var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKazakhstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 39.9999C31.0457 39.9999 40 31.0456 40 19.9999C40 8.95424 31.0457 -6.10352e-05 20 -6.10352e-05C8.9543 -6.10352e-05 0 8.95424 0 19.9999C0 31.0456 8.9543 39.9999 20 39.9999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3044 20.2173H8.69568C8.69568 21.7781 10.0551 23.0434 11.6158 23.0434H11.5218C11.5218 24.6042 12.787 25.8695 14.3479 25.8695C14.3479 27.4303 15.6131 28.6956 17.174 28.6956H22.8261C24.387 28.6956 25.6522 27.4303 25.6522 25.8695C27.2131 25.8695 28.4783 24.6042 28.4783 23.0434H28.3843C29.9448 23.0434 31.3044 21.7781 31.3044 20.2173V20.2173Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.826 16.5216C27.826 20.8438 24.3221 24.3477 19.9999 24.3477C15.6777 24.3477 12.1738 20.8438 12.1738 16.5216",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9777 16.5216L23.5351 17.6706L24.8358 20.0362L22.1835 19.5288L21.8474 22.2081L20 20.2374L18.1525 22.2081L17.8164 19.5288L15.1641 20.036L16.4647 17.6705L14.0222 16.5216L16.4648 15.3727L15.1641 13.0071L17.8164 13.5145L18.1525 10.8351L20 12.8058L21.8475 10.8351L22.1835 13.5145L24.8359 13.0071L23.5352 15.3727L25.9777 16.5216Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKazakhstan);
export default __webpack_public_path__ + "static/media/kazakhstan.6ebcaa8196f4dd52ef79d85b7ab9e010.svg";
export { ForwardRef as ReactComponent };